import { StandardQuizQuestion } from '@/types/quizTypes';

export const OWASP_TESTING_QUIZ: StandardQuizQuestion[] = [
  {
    id: "owasp-1",
    question: "What is the OWASP Top 10?",
    options: [
      "Top 10 programming languages",
      "List of top 10 most critical web application security risks",
      "Top 10 websites",
      "Top 10 cloud providers"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The OWASP Top 10 is a regularly-updated list of the most critical security risks for web applications, providing awareness and guidance for developers and security professionals.",
    category: "owasp-basics",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "owasp-2",
    question: "What is SQL Injection?",
    options: [
      "Adding new SQL features",
      "Inserting malicious SQL code through user inputs",
      "Database backup",
      "SQL optimization"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "SQL Injection occurs when attackers insert malicious SQL commands through user inputs, potentially accessing, modifying, or deleting database data. Use parameterized queries to prevent it.",
    category: "injection",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "owasp-3",
    question: "What is Cross-Site Scripting (XSS)?",
    options: [
      "Legitimate JavaScript",
      "Injecting malicious scripts into web pages viewed by others",
      "CSS optimization",
      "Browser caching"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "XSS allows attackers to inject malicious scripts (usually JavaScript) into web pages. When other users view these pages, the scripts execute, potentially stealing data or performing actions.",
    category: "xss",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "owasp-4",
    question: "What is CSRF (Cross-Site Request Forgery)?",
    options: [
      "A data format",
      "Tricking users into executing unwanted actions on authenticated sites",
      "A database attack",
      "A network protocol"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "CSRF tricks authenticated users into unknowingly performing actions (transfers, changes) on a web application where they're logged in. Prevented using CSRF tokens and SameSite cookies.",
    category: "csrf",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "owasp-5",
    question: "What is Broken Access Control?",
    options: [
      "Physical door security",
      "Failure to enforce proper authorization allowing unauthorized access",
      "Network firewall issue",
      "Database corruption"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Broken Access Control occurs when users can access resources or perform actions they shouldn't. Examples: viewing others' data, accessing admin functions, or modifying data without permission.",
    category: "access-control",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "owasp-6",
    question: "What is Security Misconfiguration?",
    options: [
      "Wrong cable connections",
      "Insecure default configs, incomplete setup, or verbose errors",
      "Slow performance",
      "Poor UI design"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Security Misconfiguration includes default passwords, unnecessary features enabled, verbose error messages exposing info, missing security headers, or outdated software versions.",
    category: "misconfiguration",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "owasp-7",
    question: "What is the purpose of penetration testing?",
    options: [
      "Testing network speed",
      "Simulating attacks to identify security vulnerabilities",
      "Testing user interfaces",
      "Performance benchmarking"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Penetration testing (pen testing) involves ethical hackers simulating real attacks to discover and exploit vulnerabilities before malicious actors do, helping organizations improve security.",
    category: "penetration-testing",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "owasp-8",
    question: "What is the principle of least privilege?",
    options: [
      "Giving maximum permissions",
      "Granting minimum necessary permissions for a task",
      "No permissions for anyone",
      "Everyone gets same permissions"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "The principle of least privilege states that users, processes, and systems should have only the minimum permissions necessary to perform their functions, limiting damage from compromises.",
    category: "security-principles",
    points: 15,
    type: "multiple-choice"
  }
];

export const generateOwaspTestingQuiz = () => ({
  questions: OWASP_TESTING_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'security-testing'
});
